export default __webpack_public_path__ + "static/media/pack-3.1b76f09f.png";